// Built-ins
import React from "react";

// Modules / Functions
import axios from "axios";
import Swal from "sweetalert2";

// Icons / Images
import { FaMapMarkerAlt, FaGlobe } from "react-icons/fa";
import { BsInfoSquare } from "react-icons/bs";
import { Card } from "react-bootstrap";
import { Grid } from "semantic-ui-react";
import { MdCreditCard } from "react-icons/md";
import { IoMdBusiness } from "react-icons/io";
import { FaMinus } from "react-icons/fa";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { GiConvergenceTarget } from "react-icons/gi";
import { BsMailbox } from "react-icons/bs";

import { FaHashtag, FaCheck } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdAlternateEmail } from "react-icons/md";
import { ImCross } from "react-icons/im";

// Custom Made Components
import ChangeName from "../../../modals/change_name";
import ChangeAddress from "../../../modals/change_address";
import ChangeEmail from "../../../modals/change_email";
import ChangeTel from "../../../modals/change_tel";
import ChangeWebsite from "../../../modals/change_website";
import ChangeEnabled from "../../../modals/change_enabled";
import ChangeLatLng from "../../../modals/change_lat_lng";
import GoogleMap from "../../../core/map/map";
import DeleteObjectModal from "../../../modals/delete_object";
import EditPaymentDetails from "../../../modals/edit_payment_details";
import Notes from "../../../core/notes/notes";
import ContactPersons from "../../../core/contact_persons/contact_persons";
import ChangeAddress2 from "../../../modals/change_address2";
import ChangePostal from "../../../modals/change_postal";
import ChangeRegion from "../../../modals/change_region";

// Global Variables
import {
  headers,
  loader,
  pageHeader,
  forbidden,
  restrictedUsers,
  iconStyle,
} from "../../../global_vars";

// Variables
window.Swal = Swal;

let overviewIconStyle = { color: "#F3702D", marginRight: "0.5em" };

const VIEW_PRIVATE_TRANSFER = "https://groupplan.gr/api/data_management/private_transfer/";

function getPrivateTransferId() {
  return window.location.pathname.split("/")[3];
}

class PrivateTransferOverView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      private_transfer: {
        notes: [],
      },
      contact_persons: [],
      is_loaded: false,
      forbidden: false,
      show_tel2: false,
      show_address2: false,
    };
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    if (restrictedUsers().includes(localStorage.getItem("user"))) {
      this.setState({
        forbidden: true,
      });
    }
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_PRIVATE_TRANSFER + getPrivateTransferId(), {
        headers: headers,
      })
      .then((res) => {
        const private_transfer = res.data.private_transfer || {};
        this.setState({
          private_transfer: {
            ...private_transfer,
            contact: private_transfer.contact || {},
            payment_details: private_transfer.payment_details || {},
            notes: private_transfer.notes || [],
            contact_persons: private_transfer.contact_persons || [],
          },
          notes: private_transfer.notes || [],
          contact_persons: private_transfer.contact_persons || [],
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  }

  update_state = (update_state) => {
    this.setState({ private_transfer: update_state });
  };

  refresh = () => {
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_PRIVATE_TRANSFER + getPrivateTransferId(), {
        headers: headers,
      })
      .then((res) => {
        const private_transfer = res.data.private_transfer || {};
        this.setState({
          private_transfer: {
            ...private_transfer,
            contact: private_transfer.contact || {},
            payment_details: private_transfer.payment_details || {},
            notes: private_transfer.notes || [],
            contact_persons: private_transfer.contact_persons || [],
          },
          is_loaded: true,
        });
      });
  };

  update_private_transfer = (private_transfer) => {
    this.setState({ private_transfer: private_transfer });
  };

  update_notes = (notes) => {
    var private_transfer = { ...this.state.private_transfer };
    private_transfer.notes = notes;
    this.setState({
      private_transfer: private_transfer,
    });
  };

  add_contact_person = (contact_persons) => {
    var private_transfer = { ...this.state.private_transfer };
    private_transfer.contact_persons = contact_persons;
    this.setState({
      private_transfer: private_transfer,
      contact_persons: contact_persons,
    });
  };

  render() {
    return (
      <>
        <div className="mainContainer">
          {pageHeader(
            "private_transfer_overview",
            this.state.private_transfer.name
          )}
          {this.state.forbidden ? (
            <>{forbidden("Private Transfer Overview")}</>
          ) : this.state.is_loaded ? (
            <>
              <Grid stackable columns={2} divided>
                <Grid.Column>
                  <Card>
                    <Card.Header>
                      <BsInfoSquare
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Private Transfer Information
                    </Card.Header>
                    <Card.Body>
                      <div className={"info_descr"}>
                        <FaHashtag style={overviewIconStyle} /> Name
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.name
                          ? this.state.private_transfer.name
                          : "N/A"}
                      </div>
                      <ChangeName
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                      />

                      <div className={"info_descr"}> <IoMdBusiness style={overviewIconStyle} /> Company </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.payment_details
                          ? this.state.private_transfer.payment_details.company === "" ||
                            this.state.private_transfer.payment_details.company === null
                            ? "N/A"
                            : 
                            <span style={{color: this.state.private_transfer.payment_details.company === this.state.private_transfer.name ? 'blue': ''}}>
                              {this.state.private_transfer.payment_details.company}
                            </span>
                          : "N/A"}
                      </div>

                      <div className={"info_descr"}>
                        <FaAddressCard style={overviewIconStyle} /> Address
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.contact.address
                          ? this.state.private_transfer.contact.address
                          : "N/A"}
                      </div>
                      <ChangeAddress
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        address={
                          this.state.private_transfer.contact.address
                            ? this.state.private_transfer.contact.address
                            : "N/A"
                        }
                      />
                      {this.state.show_address2 ? (
                        <>
                          <div className={"info_descr"}>
                            <FaAddressCard style={overviewIconStyle} /> Address
                            2
                          </div>
                          <div className={"info_span"}>
                            {this.state.private_transfer.contact.address2
                              ? this.state.private_transfer.contact.address2
                              : "N/A"}
                          </div>
                          <FaMinus
                            className="minus-icon"
                            title="Hide address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() =>
                              this.setState({ show_address2: false })
                            }
                          />
                          <ChangeAddress2
                            object_id={this.state.private_transfer.id}
                            object_name={this.state.private_transfer.name}
                            object_type={"Private Transfer"}
                            update_state={this.update_state}
                            address={
                              this.state.private_transfer.contact.address2
                                ? this.state.private_transfer.contact.address2
                                : "N/A"
                            }
                          />
                        </>
                      ) : (
                        <>
                          <AiOutlinePlusSquare
                            className="plus-icon"
                            title="Show Address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() =>
                              this.setState({ show_address2: true })
                            }
                          />
                        </>
                      )}
                      <div className={"info_descr"}>
                        <BsFillTelephoneFill style={overviewIconStyle} /> Tel
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.contact.tel
                          ? this.state.private_transfer.contact.tel
                          : "N/A"}
                      </div>
                      <ChangeTel
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        tel_num={"tel"}
                        update_state={this.update_state}
                        telephone={
                          this.state.private_transfer.contact.tel
                            ? this.state.private_transfer.contact.tel
                            : "N/A"
                        }
                      />
                      {this.state.show_tel2 ? (
                        <>
                          <div className={"info_descr"}>
                            <BsFillTelephoneFill style={overviewIconStyle} />
                            Tel. 2
                          </div>
                          <div className={"info_span"}>
                            {this.state.private_transfer.contact.tel2
                              ? this.state.private_transfer.contact.tel2
                              : "N/A"}
                          </div>

                          <ChangeTel
                            object_id={this.state.private_transfer.id}
                            object_name={this.state.private_transfer.name}
                            object_type={"Private Transfer"}
                            tel_num={"tel2"}
                            update_state={this.update_state}
                            telephone={
                              this.state.private_transfer.contact.tel2
                                ? this.state.private_transfer.contact.tel2
                                : "N/A"
                            }
                          />
                          <div className={"info_descr"}>
                            <BsFillTelephoneFill style={overviewIconStyle} />
                            Tel. 3
                          </div>
                          <div className={"info_span"}>
                            {this.state.private_transfer.contact.tel3
                              ? this.state.private_transfer.contact.tel3
                              : "N/A"}
                          </div>

                          <FaMinus
                            className="minus-icon"
                            title="Hide address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() => this.setState({ show_tel2: false })}
                          />

                          <ChangeTel
                            object_id={this.state.private_transfer.id}
                            object_name={this.state.private_transfer.name}
                            object_type={"Private Transfer"}
                            tel_num={"tel3"}
                            update_state={this.update_state}
                            telephone={
                              this.state.private_transfer.contact.tel3
                                ? this.state.private_transfer.contact.tel3
                                : "N/A"
                            }
                          />
                        </>
                      ) : (
                        <>
                          <AiOutlinePlusSquare
                            className="plus-icon"
                            title="Show Tel 2"
                            style={{ marginLeft: 20 }}
                            onClick={() => this.setState({ show_tel2: true })}
                          />
                        </>
                      )}

                      <div className={"info_descr"}>
                        <GiConvergenceTarget style={overviewIconStyle} /> Region
                      </div>

                      <div className={"info_span"}>
                        {this.state.private_transfer.region ? this.state.private_transfer.region : 'N/A'}
                      </div>

                      <ChangeRegion
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                      />
                      <div className={"info_descr"}>
                        <BsMailbox style={overviewIconStyle} />
                        Postal / Zip code
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.contact.postal
                          ? this.state.private_transfer.contact.postal
                          : "N/A"}
                      </div>
                      <ChangePostal
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        postal={
                          this.state.private_transfer.contact.postal
                            ? this.state.private_transfer.contact.postal
                            : "N/A"
                        }
                      />
                      <div className={"info_descr"}>
                        <MdAlternateEmail style={overviewIconStyle} />
                        Email
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.contact.email
                          ? this.state.private_transfer.contact.email
                          : "N/A"}
                      </div>
                      <ChangeEmail
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                      />
                      <div className={"info_descr"}>
                        <FaGlobe style={overviewIconStyle} /> Website
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.contact.website
                          ? this.state.private_transfer.contact.website
                          : "N/A"}
                      </div>
                      <ChangeWebsite
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        website={
                          this.state.private_transfer.contact.website
                            ? this.state.private_transfer.contact.website
                            : "N/A"
                        }
                      />
                      <div className={"info_descr"}>
                        <FaMapMarkerAlt style={overviewIconStyle} />
                        Lat / Lng
                      </div>
                      <ChangeLatLng
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        lat={this.state.private_transfer.lat}
                        lng={this.state.private_transfer.lng}
                      />
                      <div className={"lat_lng_span"}>
                        {this.state.private_transfer.lat
                          ? this.state.private_transfer.lat
                          : "N/A"}
                      </div>
                      <div
                        style={{ marginLeft: 35 }}
                        className={"lat_lng_span"}
                      >
                        {this.state.private_transfer.lng
                          ? this.state.private_transfer.lng
                          : "N/A"}
                      </div>
                      <ContactPersons
                        add_contact_person={this.add_contact_person}
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        contact_persons={
                          this.state.private_transfer.contact_persons
                        }
                      />
                      <div className={"info_descr"}>
                        {this.state.private_transfer.enabled ? (
                          <FaCheck style={overviewIconStyle} />
                        ) : (
                          <ImCross style={overviewIconStyle} />
                        )}
                        Enabled
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.enabled
                          ? "Enabled"
                          : "Disabled"}
                      </div>
                      <ChangeEnabled
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                      />
                    </Card.Body>
                    <Card.Footer>
                      <DeleteObjectModal
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                      />
                    </Card.Footer>
                  </Card>
                  <Notes
                    update_notes={this.update_notes}
                    object_id={this.state.private_transfer.id}
                    object_name={this.state.private_transfer.name}
                    object_type={"Private Transfer"}
                    update_state={this.update_state}
                    notes={this.state.private_transfer.notes}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Card>
                    <Card.Header>
                      <MdCreditCard style={iconStyle} />
                      Payment Details
                    </Card.Header>
                    <Card.Body>
                      <div className={"info_descr"}> Company </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.payment_details
                          ? this.state.private_transfer.payment_details
                              .company === "" ||
                            this.state.private_transfer.payment_details
                              .company === null
                            ? "N/A"
                            : this.state.private_transfer.payment_details.company
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}> Currency </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.payment_details
                          ? this.state.private_transfer.payment_details
                              .currency === "" ||
                            this.state.private_transfer.payment_details
                              .currency === null
                            ? "N/A"
                            : this.state.private_transfer.payment_details.currency
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}>
                        {this.state.private_transfer.payment_details.currency ===
                        "GBP"
                          ? "Account Number"
                          : "IBAN"}
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.payment_details
                          ? this.state.private_transfer.payment_details.iban ===
                              "" ||
                            this.state.private_transfer.payment_details.iban ===
                              null
                            ? "N/A"
                            : this.state.private_transfer.payment_details.iban
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}>
                        {this.state.private_transfer.payment_details.currency ===
                        "GBP"
                          ? "Sort Code"
                          : "Swift"}
                      </div>
                      <div className={"info_span"}>
                        {this.state.private_transfer.payment_details
                          ? this.state.private_transfer.payment_details.swift ===
                              "" ||
                            this.state.private_transfer.payment_details.swift ===
                              null
                            ? "N/A"
                            : this.state.private_transfer.payment_details.swift
                          : "N/A"}
                      </div>
                    </Card.Body>
                    <Card.Footer>
                      <EditPaymentDetails
                        object_id={this.state.private_transfer.id}
                        object_name={this.state.private_transfer.name}
                        object_type={"Private Transfer"}
                        update_state={this.update_state}
                        payment_details={
                          this.state.private_transfer.payment_details
                        }
                      />
                    </Card.Footer>
                  </Card>
                  <Card>
                    <Card.Header>
                      <FaMapMarkerAlt
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Map with private transfer's location
                    </Card.Header>
                    {this.state.private_transfer.lat ||
                    this.state.private_transfer.lng ? (
                      <>
                        <Card.Body>
                          <GoogleMap object={this.state.private_transfer} />
                        </Card.Body>
                      </>
                    ) : (
                      <strong
                        style={{ textAlign: "center", margin: 20, padding: 20 }}
                      >
                        Update latitude / longitude to show private transfer's
                        location on map
                      </strong>
                    )}
                    <Card.Footer>
                      <small className="mr-auto">
                        <BsInfoSquare
                          style={{
                            color: "#F3702D",
                            fontSize: "1.5em",
                            marginRight: "0.5em",
                          }}
                        />
                        Changing private transfer's lat/lng will also change the
                        map's pin
                      </small>
                    </Card.Footer>
                  </Card>
                </Grid.Column>
              </Grid>
            </>
          ) : (
            loader()
          )}
        </div>
      </>
    );
  }
}

export default PrivateTransferOverView;
